export default __webpack_public_path__ + "static/media/upload-success.64217455.svg";